import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../Layout/Footer';
import Header from '../Layout/Header';
import taskimage from '../../assets/img/taskimg.png';
import { Card } from 'react-bootstrap';
import { BiTimeFive } from 'react-icons/bi';
import { useState } from 'react';
import { browseSearch } from '../../Redux/Home/action';
import moment from 'moment';
import feedback from '../../assets/img/notify.jpg';
import { getMyTaskList } from '../../Redux/Task/action';


const SearchList = () => {

    // const [tasks, setTasks] = useState([])
    const [data, setData] = useState([]);

    // useEffect(() => {
    //     let formData = new FormData();
    //     getMyTaskList({ formData })((response) => {
    //         if (response && response.status) {
    //             setTasks(response?.data?.data)
    //         }
    //     });
    // }, []);

    const __search = (e) => {
        browseSearch(e?.target?.value)((response) => {
            if (response?.status && response?.data) {
                setData(response?.data?.data)
            }
        });
    }
    return (
        <React.Fragment>
            <Header search={true} />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>
                                    Search Services </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Search Services</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='browse-tasks'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className='col-lg-12'>
                                <form className="search-form d-flex align-items-center justify-content-center" >
                                    <input type="text" name="query" placeholder="Search" title="Search" onChange={(e) => __search(e)} className='w-50' />
                                    <button type="submit" title="Search">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" className='search-icon searchlist-icon' fill="#fff" viewBox="0 0 16 16">
                                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                        </svg>
                                    </button>
                                </form>
                            </div>
                            <div className="mytask-buyer section-bg p-0">
                                <div className="container">
                                    <div className="row mt-4">
                                        {data?.map((task, index) =>
                                            <React.Fragment>
                                                <div className="col-lg-4">
                                                    <div className="member d-flex align-items-start">
                                                        <div className='col-lg-2'>
                                                            <div className="pic"><img src={feedback} className="img-fluid" alt="" /></div>
                                                        </div>
                                                        <div className='col-lg-10'>
                                                            <div className="member-info">
                                                                <h4>{task?.title}</h4>
                                                                <p><i className="bi bi-calendar"></i> {moment(task?.task_details?.date_choice).format('ll')}</p>
                                                                <p><i className="bi bi-clock"></i> 10 AM - 2 PM</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </React.Fragment>
                                        )}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    )
}

export default SearchList;